import styled, { css } from 'styled-components';

import { basicSmallTextStyle, Text } from '@dreryk/react-components';

type StyledSpecialtiesTextProps = {
   $compact: boolean | undefined;
   $secondary: boolean | undefined;
};

export const StyledSpecialtiesText = styled(Text)<StyledSpecialtiesTextProps>`
   ${(props) =>
      props.$secondary &&
      css`
         color: ${props.theme.placeholder};
      `}

   ${(props) =>
      props.$compact &&
      css`
         ${basicSmallTextStyle}
      `}
`;

StyledSpecialtiesText.displayName = 'StyledSpecialtiesText';
